import { z } from "zod";
export var securityContextRequiredRoleSchema = z.object({
    permissionName: z.string(),
    requiredRoleTypeId: z.string(),
    requiredRoleId: z.string()
});
export var securityContextSchema = z.object({
    requiredRoles: z.array(securityContextRequiredRoleSchema)
});
//# sourceMappingURL=SecurityContext.zod.js.map